/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { RenderPieceFunction, PopupMenuItem, PopupMenu } from 'components';
import FenParser from '@chess-fu/fen-parser';
import { ChessPiece } from 'components/board/chessTypes';

/** GameOptionsProps - Properties */
export interface GameOptionsProps {
  fen: string;
  optionsMenu: PopupMenuItem[];
  onPlay: () => void;
  onSetPlayer: (color: 'b' | 'w') => void;
  onSetCastles: (value: string) => void;
  renderPiece: RenderPieceFunction;
}

/** GameOptions */
export class GameOptions extends React.Component<GameOptionsProps> {
  constructor(props: GameOptionsProps, ctx: any) {
    super(props, ctx);
  }

  togglePlayer = (e: React.SyntheticEvent<any>) => {
    const target: any = e.target;
    if (target.tagName === 'A') {
      e.preventDefault();
    }
    const fenInfo = new FenParser(this.props.fen);
    const newPlayer = fenInfo.turn === 'w' ? 'b' : 'w';
    this.props.onSetPlayer(newPlayer);
  }

  toggleCastle(side: string) {
    const fenInfo = new FenParser(this.props.fen);
    let { castles } = fenInfo;
    castles = castles.replace('-', '');
    if (castles.includes(side)) {
      castles = castles.replace(side, '');
    }
    else {
      castles += side;
    }
    castles = castles.split('').sort().join('');
    if (castles.length === 0) {
      castles = '-';
    }
    this.props.onSetCastles(castles);
  }

  render() {
    const fenInfo = new FenParser(this.props.fen);

    return (
      <Mui.Typography variant="body1" color="secondary" component="div">
        <div className="flex top row start game-setup-options">
          <div className="flex column col-1" style={{ width: '125px' }}>
            <div className="row bottom">
              <input type="checkbox" checked={fenInfo.turn === 'w'} onChange={this.togglePlayer} />
              <a href="#" onClick={this.togglePlayer}>White to play</a>
            </div>
            <div className="row bottom left mt-4">{this.renderPiece('w', 'k')}
              <input type="checkbox" checked={fenInfo.castles.includes('K')} onChange={() => this.toggleCastle('K')} /> K <div className="spacing" />
              <input type="checkbox" checked={fenInfo.castles.includes('Q')} onChange={() => this.toggleCastle('Q')} /> Q <div className="spacing" />
            </div>
            <div className="row bottom left mt-4">{this.renderPiece('b', 'k')}
              <input type="checkbox" checked={fenInfo.castles.includes('k')} onChange={() => this.toggleCastle('k')} /> K <div className="spacing" />
              <input type="checkbox" checked={fenInfo.castles.includes('q')} onChange={() => this.toggleCastle('q')} /> Q <div className="spacing" />
            </div>
          </div>
          <div className="flex row left" style={{ width: '125px' }}>
            <Mui.Button color="secondary"
              style={{ width: '140px', justifyContent: 'flex-start' }}
              onClick={this.props.onPlay}
            ><Mui.Icon>play_arrow</Mui.Icon>Play</Mui.Button>
            <PopupMenu color="secondary" icon="settings" text="Options"
              items={this.props.optionsMenu}
            />
          </div>
        </div>
      </Mui.Typography>
    );
  }

  renderPiece(color: 'b' | 'w', type: string) {
    return this.props.renderPiece({
      piece: { color, type } as ChessPiece,
      size: { width: 24, height: 24 },
      square: { file: 'g', rank: 1, color: 'dark' }
    });
  }
}

export default GameOptions;


// WEBPACK FOOTER //
// ./src/views/setupGame/components/gameOptions.tsx